// extracted by mini-css-extract-plugin
export default {"timer":"timer_timer__KqRem","time":"timer_time__uahOW","cancel":"timer_cancel__Rquzv"};